import { useState } from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import startOfDay from 'date-fns/startOfDay';
import parseISO from 'date-fns/parseISO';
import { fonts, colors, dimensions } from '../common/Theme';

import Button from '../common/elements/Button.js';
import Form from '../common/forms/Form';
import CountrySelector from '../common/elements/CountrySelector';
import { mixed, strings, dates, validate } from '../common/forms/Validations';

import Information from './Information';
import DateControl from '../common/forms/DateControl.js';
import { Label } from '../common/elements/FormControl';

const styles = css`
  .travel__form {
    display: flex;
    flex-direction: column;
  }

  h2 {
    font-family: ${fonts.primaryFont};
  }

  .return-date {
    color: ${colors.ywgPinkishOrange};
    font-weight: bold;
    margin-bottom: ${dimensions.ywgFormSpacing};
    border: 2px solid ${colors.ywgVeryLightBlue};
    padding: 15px 0 15px 20px;
    width: auto;
  }
  .return-date__show-details {
    border: solid 1px ${colors.ywgNavy};
    color: ${colors.ywgNavy};
    font-weight: bold;
    border-radius: 50%;
    background: transparent;
    margin: 0px 6px;
  }
  .return-date__show-details:active,
  .return-date__show-details:hover {
    color: ${colors.ywgPrimary};
    border-color: ${colors.ywgPrimary};
  }
  .return-date__show-details:focus {
    outline: none;
  }
  .return-date-details--hide {
    display: none;
  }

  .return-date-details--show {
    display: inline;
    color: ${colors.ywgNavy};
    font-weight: normal;
  }
`;

const buttonStyles = css.resolve`
  button {
    max-width: 50%;
    min-width: 100px;
    align-self: flex-end;
    width: 200px;
  }
`;

const travelValidators = countries => value => {
  const today = startOfDay(new Date());
  return {
    destination: [
      strings.required.withError(''),
      mixed.oneOf(...countries.map(c => c.label))
    ],
    startDate: [
      mixed.required.withError(''),
      dates
        .isAfter(today)
        .withError(
          'La date de départ doit être dans le futur (une souscription immédiate ne prends effet que le lendemain)'
        )
    ],
    endDate: [
      dates
        .isAfter(today)
        .withError('La date de retour doit être dans le futur'),
      dates
        .isAfter(value.startDate ? parseISO(value.startDate) : today)
        .withError('la date de retour ne peut être avant la date de départ')
    ]
  };
};

const TravelStep = ({ travel, onNext, countries, className }) => {
  const [showDetails, setShowDetails] = useState(false);
  const onShowDetails = () => {
    setShowDetails(!showDetails);
  };
  return (
    <>
      <Information />
      <Form
        initialValues={travel}
        validate={value => validate(value, travelValidators(countries)(value))}
        onSubmit={onNext}
      >
        {({ values, metas, onChange, onBlur, doSubmit }) => (
          <form
            className={classnames('travel__form', className)}
            onSubmit={doSubmit}
          >
            <h2>Voyage</h2>
            <DateControl
              name="startDate"
              label="DATE DE DÉPART"
              type="date"
              mode="travel"
              value={values.startDate}
              onChange={onChange}
              error={metas.startDate}
              valid={metas.startDate.valid}
              autoFocus
              onBlur={onBlur}
              required
            />
            <Label>DATE DE RETOUR</Label>
            <p className="return-date" onClick={onShowDetails}>
              Sans engagement{' '}
              <button type="button" className="return-date__show-details">
                ?
              </button>
              <span
                className={
                  showDetails
                    ? 'return-date-details--show'
                    : 'return-date-details--hide'
                }
              >
                Arrêtez votre contrat à tout moment depuis votre espace
                voyageur, vous ne payez que les jours assurés.
              </span>
            </p>

            <CountrySelector
              label={'PAYS DE DESTINATION'}
              value={values.destination}
              name="destination"
              valid={metas.destination.valid}
              error={metas.destination.error}
              required
              onChange={onChange}
              onBlur={onBlur}
              countries={countries}
              autoComplete="off"
            />

            <Button
              type="submit"
              arrow="right"
              className={buttonStyles.className}
            >
              Bénéficiaires
            </Button>
            <style jsx>{styles}</style>
            {buttonStyles.styles}
          </form>
        )}
      </Form>
    </>
  );
};

export default TravelStep;
